import { Box, FormGroup, FormLabel } from "@mui/material";
import React from "react";
import LogFilterCheckbox from "./LogFilterCheckbox";

/**
 * A component that renders a panel of log level filter checkboxes.
 *
 * @component
 * @param {Object} props - The component props
 * @param {string[]} props.activeLogLevels - Array of currently active log level filters
 * @param {Function} props.onFilterChange - Callback function triggered when a filter is toggled
 * @returns {React.ReactElement} A form group with log level filter checkboxes
 *
 * @example
 * // Usage:
 * <LogLevelFilterPanel
 *   activeLogLevels={["DEBUG", "INFO", "ERROR"]}
 *   onFilterChange={(level) => handleFilterChange(level)}
 * />
 */
function LogLevelFilterPanel({ activeLogLevels, onFilterChange }) {
  return (
    <Box pt={2}>
      <FormLabel sx={{ display: "flex", justifyContent: "right", pr: "15px" }} htmlFor="log-level-form">
        Log Level Filter
      </FormLabel>
      <FormGroup id="log-level-form" row sx={{ display: "flex", justifyContent: "right" }}>
        <LogFilterCheckbox logLevel="DEBUG" activeFilters={activeLogLevels} onFilterChange={onFilterChange} />
        <LogFilterCheckbox logLevel="INFO" activeFilters={activeLogLevels} onFilterChange={onFilterChange} />
        <LogFilterCheckbox logLevel="EXTRA" activeFilters={activeLogLevels} onFilterChange={onFilterChange} />
        <LogFilterCheckbox logLevel="WARNING" activeFilters={activeLogLevels} onFilterChange={onFilterChange} />
        <LogFilterCheckbox logLevel="ERROR" activeFilters={activeLogLevels} onFilterChange={onFilterChange} />
      </FormGroup>
    </Box>
  );
}

export default LogLevelFilterPanel;
